import { Card, Box, Typography, Fade, CircularProgress } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function OrderCard({ order, isSelected, onClick, theme, hasError, isLoading }) {
  return (
    <Fade in timeout={300}>
      <Card
        elevation={isSelected ? 6 : 4}
        sx={{
          width: "calc(100% - 10px)",
          minHeight: { xs: 70, md: 80 },
          borderRadius: { xs: 2, md: 3 },
          cursor: "pointer",
          maxWidth: "94%",
          border: isSelected
            ? `2.5px solid ${theme.palette.warning.main}`
            : order.status === "printed"
              ? `1.5px solid ${theme.palette.success.main}`
              : `1.5px solid ${theme.palette.divider}`,
          bgcolor: isSelected
            ? `linear-gradient(135deg, #fffbe6 60%, ${theme.palette.warning.light} 100%)`
            : order.status === "printed"
              ? `linear-gradient(135deg, #f0f8f0 60%, ${theme.palette.success.light} 100%)`
              : `linear-gradient(135deg, #fff 60%, ${theme.palette.action.hover} 100%)`,
          boxShadow: isSelected
            ? "0 6px 32px 0 rgba(255, 152, 0, 0.22)"
            : "0 2px 12px 0 rgba(140,140,140,0.10)",
          transition: "all 0.22s cubic-bezier(.4,0,.2,1)",
          position: "relative",
          display: "flex",
          alignItems: "center",
          px: { xs: 1.5, md: 2 },
          py: { xs: 1.5, md: 2 },
          "&:hover": {
            boxShadow: "0 8px 36px 0 rgba(255, 152, 0, 0.25)",
            border: `2.5px solid ${theme.palette.warning.main}`,
            bgcolor: `linear-gradient(135deg, #fffbe6 60%, ${theme.palette.warning.light} 100%)`,
          },
        }}
        onClick={onClick}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          width="100%"
          position="relative"
        >
          {/* Indicador de pedido impresso */}
          {order.status === "printed" && (
            <CheckCircleIcon
              sx={{
                position: "absolute",
                top: -8,
                right: -8,
                zIndex: 1,
                fontSize: 20,
                color: "success.main",
                backgroundColor: "white",
                borderRadius: "50%",
                padding: 0.5,
              }}
            />
          )}
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              background:
                order.channel === "SHOPEE"
                  ? "linear-gradient(135deg, #ff9800 60%, #fffbe6 100%)"
                  : order.channel === "MERCADO_LIVRE"
                    ? "linear-gradient(135deg, #ffe600 60%, #fff 100%)"
                    : order.channel === "AMAZON"
                      ? "linear-gradient(135deg, #232f3e 60%, #fff 100%)"
                      : order.channel === "MAGALU"
                        ? "linear-gradient(135deg, #00aaff 60%, #fff 100%)"
                        : "linear-gradient(135deg, #ff9800 60%, #fff 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            {isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : hasError ? (
              <ErrorIcon sx={{ color: "#fff", fontSize: 20 }} />
            ) : (
              <Typography fontWeight={900} color="#fff" fontSize={18}>
                {order.channel?.[0] || "?"}
              </Typography>
            )}
          </Box>
          <Box flex={1} minWidth={0}>
            <Typography
              variant="subtitle1"
              color="warning.main"
              fontWeight={900}
              letterSpacing={0.5}
              sx={{
                textShadow: isSelected
                  ? "0 1px 4px rgba(255,152,0,0.18)"
                  : "none",
                transition: "color 0.2s",
                fontSize: 14,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                mb: 0.5,
              }}
            >
              Pedido: {order.content?.invoice_number || order._id}
            </Typography>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              sx={{ mt: 1 }}
            >
              <Typography variant="caption" color="text.secondary">
                {order.channel?.replace(/_/g, " ")}
              </Typography>
              <Typography
                variant="body2"
                color="success.main"
                fontWeight={700}
                sx={{ fontSize: 16 }}
              >
                R${" "}
                {order.content?.invoice_amount?.toFixed(2).replace(".", ",") ||
                  "0,00"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>
    </Fade>
  );
}

export default OrderCard;
